import styled from 'styled-components';

export const Container = styled.div`
  background: #0a192f;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccd6f6;
  text-align: center;
  padding: 2rem;
`;

export const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Logo = styled.svg`
  width: 80px;
  height: 60px;
  opacity: 0.9;
  filter: drop-shadow(0 0 8px rgba(100, 255, 218, 0.3));
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const Heading = styled.h1`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  background: linear-gradient(45deg, #64ffda, #57cbff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.03em;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const Tagline = styled.p`
  font-size: 1.5rem;
  margin-bottom: 3rem;
  opacity: 0.9;
  font-weight: 300;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const ComingSoon = styled.div`
  font-size: 1.2rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: rgba(100, 255, 218, 0.8);
  margin-bottom: 3rem;
  animation: fadeInOut 2s ease-in-out infinite;

  @keyframes fadeInOut {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
  }
`;

export const CompanyName = styled.h2`
  font-size: 2.5rem;
  color: #64ffda;
  letter-spacing: -0.03em;
  margin: 0;
  font-weight: 600;
`;